import { Bills } from 'actions/actionTypes';

export const loadShopBillsRequest = () => ({ type: Bills.LOAD_SHOP_BILLS_REQUEST });
export const loadShopBillsRequestSuccess = (responseData) => ({ type: Bills.LOAD_SHOP_BILLS_REQUEST_SUCCESS, payload: responseData });
export const loadShopBillsRequestFailure = (errorMessage) => ({ type: Bills.LOAD_SHOP_BILLS_REQUEST_FAILURE, payload: errorMessage });

export const loadShopBillsDetailRequest = (id) => ({ type: Bills.LOAD_SHOP_BILLS_DETAIL_REQUEST, payload: id });
export const loadShopBillsDetailRequestSuccess = (responseData) => ({ type: Bills.LOAD_SHOP_BILLS_DETAIL_REQUEST_SUCCESS, payload: responseData });
export const loadShopBillsDetailRequestFailure = (errorMessage) => ({ type: Bills.LOAD_SHOP_BILLS_DETAIL_REQUEST_FAILURE, payload: errorMessage });
